import { Injectable, Injector } from "@angular/core";
import { ModuleService } from "./ModuleService";

export type MagstripeReaderEvents = {
  OnMagstripeReaderCardDataReceived_Event: { Idx: number, ComponentModelName: string, Payload: string },
  OnMagstripeReaderConnected_Event: "OnMagstripeReaderConnected_Event",
  OnMagstripeReaderConnectedError_Event: "OnMagstripeReaderConnectedError_Event",
  OnMagstripeReaderDisconnected_Event: "OnMagstripeReaderDisconnected_Event",
  OnMagstripeReaderDisconnectedError_Event: "OnMagstripeReaderDisconnectedError_Event"
}

@Injectable({
  providedIn: 'root'
})
export class MagstripeReaderModuleService extends ModuleService {
  constructor(public injector: Injector) {
    super("MagstripeReader", injector)
  }

  enable(enable: boolean = true): Promise<void> {
    return this.callMethod('MagstripeReader_EnableRead', enable)
  }

  listen<T extends keyof MagstripeReaderEvents>(event: T, cb: (event: MagstripeReaderEvents[T]) => void, once: boolean = false) {
    return this[once ? 'once' : 'on'](event, cb);
  }
}
